import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ReactSession } from "../../../lib/secure_reactsession";
import { getPageTitle } from "../../../lib/pageTitle";
import { LayoutResearcher } from '../../themes/userq/Layouts/layout_researcher';
import {
	getResearcherTestResultData,
	getTestParticipantsDataV2,
} from "../../../services/researcher_test_results";
import toast from "react-hot-toast";
import moment from "moment";
import { atom, useRecoilState } from 'recoil';
import { testResultAtomFamily, testProjectAtomFamily } from "../../../store/testResultAtoms";
import { LoadingIcon } from "../../loader/loadingIconNew";
import { TestResultsHeader } from '../../themes/userq/TestResultsHeader/TestResultsHeader';
import { TestResultsSidebarNavigation } from './components/test_results_sidebar_navigation';
import { PieStatsBox } from "./components/pie_stats_box";
import { CirclesGroupStatsBox } from "./components/circles_group_stats_box";
import { HorizontalBarChartStatsBox } from "./components/horizontal_bar_chart_stats_box";
import { DevicesStatsBox } from "./components/devices_stats_box";
import { Text } from "../../themes/userq/Text/Text";
import { VerticalBarChartStatsBox } from "./components/vertical_bar_chart_stats_box";
import { AppsStatsBox } from "./components/apps_stats_box";
import { Icon } from "../../themes/userq/Icon/Icon";
import { NoParticipants } from "./components/no_participants";
import { ParticipantsNotAvailable } from "./components/participants_not_available";
import { HorizontalBarChartResidencyStatsBox } from "./components/horizontal_bar_chart_residency_stats_box";
import { Helmet } from "react-helmet";
import { renderTestTitle } from "../../../lib/helpers";

export default function TestResultParticipants({ isSharedLink }) {
	let { test_id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const [isLoading, setLoading] = useState(false);
	const [sectionLoading, setSectionLoading] = useState(false);

	const partiState = atom({
		key: 'testresultparti-' + test_id,
		default: null
	});

	const [test, setTest] = useRecoilState(testResultAtomFamily(test_id));
	const [parti, setParti] = useRecoilState(partiState);
	const [project, setProject] = useRecoilState(testProjectAtomFamily(test_id));
	const [show_support_panel, setShowSupportPanel] = useState(false);

	const getParticipants = () => {
		let token = ReactSession.get("token");

		setSectionLoading(true);

		let guest_result_token = '';

		if (location.pathname.substr(1, 1) === 'v') {
			if (!ReactSession.get("guest_result_token")) {
				const randomToken = Math.random().toString(36).substr(2, 15);
				ReactSession.set("guest_result_token", randomToken);
			}
			guest_result_token = ReactSession.get("guest_result_token");
		}

		let admin_result_token = '';

		if (location.pathname.substr(1, 1) === 'a') {
			if (!ReactSession.get("admin_result_token")) {
				const randomToken = Math.random().toString(36).substr(2, 15);
				ReactSession.set("admin_result_token", randomToken);
			}
			admin_result_token = ReactSession.get("admin_result_token");
		}

		getTestParticipantsDataV2(test_id, token, guest_result_token, admin_result_token).then((response) => {
			setSectionLoading(false);

			if (response.success) {
				setParti(response.data);
			} else {
				toast(
					<div className="toastinner">
						{response.message}
						<a onClick={() => { toast.dismiss(); }}>&times;</a>
					</div>,
					{
						className: response.success ? "successtoast" : "errortoast",
						position: "bottom-center",
						duration: 2000,
					}
				);
			}
		});
	};

	const getTest = (forceRefresh = false) => {
		if (!test || forceRefresh) {
			let token = ReactSession.get("token");

			if (!forceRefresh) setLoading(true);

			let guest_result_token = '';

			if (location.pathname.substr(1, 1) === 'v') {
				if (!ReactSession.get("guest_result_token")) {
					const randomToken = Math.random().toString(36).substr(2, 15);
					ReactSession.set("guest_result_token", randomToken);
				}
				guest_result_token = ReactSession.get("guest_result_token");
			}

			let admin_result_token = '';

			if (location.pathname.substr(1, 1) === 'a') {
				if (!ReactSession.get("admin_result_token")) {
					const randomToken = Math.random().toString(36).substr(2, 15);
					ReactSession.set("admin_result_token", randomToken);
				}
				admin_result_token = ReactSession.get("admin_result_token");
			}

			getResearcherTestResultData({ test_id: test_id, guest_result_token: guest_result_token, admin_result_token: admin_result_token }, token).then((response) => {
				setLoading(false);

				if (response.success) {
					if (!forceRefresh) {
						if (response.workspace_project_team_member) {
							if (response.workspace_project_team_member.status != 'active') {
								navigate("/wsp/" + response.workspace_project_team_member.workspace_id + "/p/" + response.workspace_project_team_member.workspace_project_id + "/project-no-access");
							}
						}
						if (response.test && response.test.workspace_project) {
							setProject(response.test.workspace_project);
						}
						if (location.pathname.substr(1, 1) === 'v' && response.is_share_result) {
							navigate(`/v/results/${test_id}/results-not-available`);
						}
						if (location.pathname.substr(1, 1) === 'v' && response.test.password && !response.test_password_verify) {
							navigate(`/v/results/${test_id}/password`);
						}
					}

					setTest(response.test);
					getParticipants();
				} else {
					if (!forceRefresh) {
						if (response.message == "Project not found.") {
							navigate("/404");
						} else if (response.message == "Test Record Not found") {
							navigate("/404");
						} else {
							if (location.pathname.substr(1, 1) === 'v') {
								if (response.test_shared_results && !response.test_password_verify) {
									return navigate(`/v/results/${test_id}/password`);
								} else if (!response.test_shared_results) {
									return navigate(`/v/results/${test_id}/results-not-available`);
								}
							}
							if (location.pathname.substr(1, 1) === 'a') {
								if (!response.test_results_available) {
									return navigate(`/v/results/${test_id}/results-not-available`);
								}
							}
							toast(
								<div className="toastinner">
									{response.message}
									<a onClick={() => { toast.dismiss(); }}>&times;</a>
								</div>,
								{
									className: response.success ? "successtoast" : "errortoast",
									position: "bottom-center",
									duration: 2000,
								}
							);
						}
					} else {
						navigate("/dashboard");
						toast(
							<div className="toastinner">
								{response.message}
								<a onClick={() => { toast.dismiss(); }}>&times;</a>
							</div>,
							{
								className: response.success ? "successtoast" : "errortoast",
								position: "bottom-center",
								duration: 2000,
							}
						);
					}
				}
			});
		} else {
			getParticipants();
		}
	};

	useEffect(() => {
		getTest();
	}, []);

	const callbackTopbar = () => {
		getTest(true);
	};

	const getTotalParticipants = () => {
		var total = 0;
		for (var key in parti.gender) {
			total += parti.gender[key];
		}
		return total == 0 ? true : false;
	};

	return (
		<LayoutResearcher
			isSharedLink={isSharedLink}
			fixed_header_target={true}
			isLoading={false}
			wrapClass={"researcher-test-view-overflow create-test-data-wrapper"}
			resultHeaderClass={"result-header"}
			skipCheck={false}
			extendedFooter={false}
			activeMenu={""}
			openSupportPanel={show_support_panel}
			hideSupportPanel={() => { setShowSupportPanel(false); }}
		>
			<div className="three-column-layout two-column-layout">
				<Helmet>
					<title>{getPageTitle("Participants" + (test && test.methodology ? " - " + renderTestTitle(test.methodology) : ""))}</title>
				</Helmet>
				{isLoading &&
					<div className="page-loader full-page-loader">
						<LoadingIcon />
					</div>
				}
				{!isLoading && test &&
					<>
						<TestResultsHeader
							project={project}
							isSharedLink={isSharedLink}
							test={test}
							endedOn={test.status === 'completed' ? moment.utc(test.ended_on).format('DD-MM-Y') : ''}
							callbackTopbar={callbackTopbar}
						/>

						<div className="three-column-layout-body">
							<div className="three-column-layout-left">
								<TestResultsSidebarNavigation
									isSharedLink={isSharedLink}
									methodology={(test.methodology === 'Five Seconds Test') ? "5 second test" : test.methodology}
									selected_index={2}
									screening={test && test.screening_questions && test.screening_questions.length > 0 ? "Yes" : "No"}
									test_id={(location.pathname.substr(1, 1) === 'v') ? test_id : test.id}
								/>
							</div>
							<div className="two-column-right-side">
								<div className="test-result-inner-data">
									{sectionLoading &&
										<div className="page-loader accountloading-box result-sections-loader">
											<LoadingIcon />
										</div>
									}
									{!sectionLoading && parti &&
										<>
											{parti && parti.testSharedTargetGroupWithAllGuest ?
												<div className="participants-result-page-data">
													<ParticipantsNotAvailable small={false} />
												</div>
												:
												<>
													{getTotalParticipants() ?
														<NoParticipants small={false} />
														:
														<div className="participants-result-page-data">
															<div className="parti-overflow-top-graph-wrap mb-60">
																<div className="mb-20 box-outer-heading">
																	<Text type={"h4"}>Participants overview</Text>
																</div>

																{parti && (parti.gender || parti.age) &&
																	<div className="result-pie-chart-wrap box-full-width">
																		<div className="row">
																			<div className="col-lg-6">
																				<PieStatsBox data={parti.age} title={"Age"} />
																			</div>
																			<div className="col-lg-6">
																				<PieStatsBox data={parti.gender} title={"Gender"} />
																			</div>
																		</div>
																	</div>
																}
																{parti && (!parti.gender && !parti.age) &&
																	<div className="row">
																		<div className="col-md-6">
																			<div className="info-not-available">No info available</div>
																		</div>
																	</div>
																}
															</div>

															<div className="partis-nationalities-wrap mb-60">
																<CirclesGroupStatsBox data={parti.nationalities} title={"Nationalities"} />
															</div>

															<div className="horizontal-chart-wrapper mb-60">
																<HorizontalBarChartResidencyStatsBox data={parti.countries} title={"Residency"} />
															</div>

															<div className="horizontal-chart-wrapper mb-60">
																<HorizontalBarChartStatsBox data={parti.education} title={"Minimum level of education"} />
															</div>

															<div className="result-pie-chart-wrap result-device-wrap box-full-width mb-60">
																<div className="mb-20 box-outer-heading">
																	<Text type={"h4"}>Confidence with technology</Text>
																</div>
																<div className="row">
																	<div className="col-lg-6">
																		<PieStatsBox title="Average time spent per day" data={parti.hours} />
																	</div>
																	<div className="col-lg-6">
																		<DevicesStatsBox title="Favorite devices" devices={parti.devices} active={parti.include_devices} />
																	</div>
																</div>
															</div>

															<div className="apps-stats-chart-wrap mb-60">
																<AppsStatsBox title="Most apps used daily" apps={parti.apps} />
															</div>

															<div className="horizontal-chart-wrapper mb-60">
																<HorizontalBarChartStatsBox title={"Current employment status"} data={parti.employment} />
															</div>

															<div className="vertical-chart-wrapper mb-60">
																<VerticalBarChartStatsBox id="industry" marginLeft={160} marginRight={160} title={"Industry"} data={parti.industry} />
															</div>

															<div className="vertical-chart-wrapper mb-60">
																<VerticalBarChartStatsBox id="department" title={"Department"} data={parti.department} marginLeft={50} marginRight={50} />
															</div>

															<div className="horizontal-chart-wrapper mb-60">
																<HorizontalBarChartStatsBox data={parti.people} title={"Household"} />
															</div>

															<div className="vertical-chart-wrapper household-income-chart">
																<VerticalBarChartStatsBox id="household_income" title={"Household income $"} data={parti.income} marginLeft={80} marginRight={80} />
															</div>
														</div>
													}
												</>
											}

											<div className="participants-result-responsive-section">
												<div className="mobile-charts-not-available">
													<div className="no-data-icon">
														<Icon value={"Attention"} size={"large"} />
													</div>
													<p>
														This page is not available on mobile. Please log in from a desktop device to access it.
													</p>
												</div>
											</div>
										</>
									}
								</div>
							</div>
						</div>
					</>
				}
			</div>
			{!isSharedLink &&
				<a
					onClick={(e) => {
						e.preventDefault();
						setShowSupportPanel(true);
					}}
					href={process.env.REACT_APP_URL + "r/support"}
					target="_blank"
					className='support-button'
				>
					<Icon value={"support"} colorClass={"gray-50-svg"} size={"medium"} />
					Support
				</a>
			}
		</LayoutResearcher>
	);
}
